module.exports = __webpack_public_path__ + "static/media/bg-desk-4.55ac4570.jpg";